module.exports = __webpack_public_path__ + "img/iskolafejlesztes-2.29319a7d.jpg";